// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity_bar {
    display: flex;
    flex-direction: column;
    width: 53px;
    height: 100%;
    background-color: var(--color-bg-2);
    border-right: 1px solid var(--color-border);
    flex-shrink: 0;
    overflow: visible;
}

/* Nav items */

.activity_bar__nav {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.activity_bar__item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 53px;
    height: 53px;
    background: none;
    border: none;
    border-left: 2px solid transparent;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 0;
    transition: color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__item:hover {
        color: var(--color-text);
    }
}

.activity_bar__item.active {
    color: var(--color-text);
    border-left-color: var(--color-accent);
}

.activity_bar__item_label {
    writing-mode: vertical-lr;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    user-select: none;
}

/* Separator between section items and toggle items */

.activity_bar__separator {
    height: 1px;
    background-color: var(--color-border);
    margin: 4px 9px;
    flex-shrink: 0;
}

/* Account at bottom */

.activity_bar__bottom {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 13px;
    margin-top: auto;
}

.activity_bar__account_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    border-radius: 50%;
}

.activity_bar__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 31px;
    height: 31px;
    border-radius: 50%;
    background-color: var(--color-accent);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    user-select: none;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__account_btn:hover .activity_bar__avatar {
        background-color: var(--color-accent-hover);
    }
}

.activity_bar__account_dropdown[data-open="false"] {
    opacity: 0;
    pointer-events: none;
}

/* Full-screen backdrop — blocks clicks from reaching elements behind the menu */

.activity_bar__account_backdrop {
    position: fixed;
    inset: 0;
    z-index: 1099;
}

/* Account dropdown — opens right and up from the avatar */

.activity_bar__account_menu {
    position: absolute;
    bottom: 0;
    left: calc(100% + 9px);
    min-width: 220px;
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 7px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.4);
    z-index: 1100;
    overflow: hidden;
}

.activity_bar__account_info {
    padding: 13px 15px;
}

.activity_bar__account_info_row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.activity_bar__account_info_text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}

.activity_bar__account_name {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-text);
}

.activity_bar__account_email {
    font-size: 13px;
    color: var(--color-text-muted);
}

.activity_bar__refresh_btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    background: none;
    border: none;
    border-radius: 5px;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__refresh_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.activity_bar__new_window_btn {
    display: none;
}

@media (pointer: fine) {
    .activity_bar__new_window_btn {
        display: flex;
    }
}

.activity_bar__account_divider {
    height: 1px;
    background-color: var(--color-border);
}

.activity_bar__sign_out {
    display: block;
    width: 100%;
    padding: 10px 15px;
    text-align: left;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 14px;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__sign_out:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.activity_bar__project_menu_empty {
    padding: 10px 15px;
    font-size: 14px;
    color: var(--color-text-muted);
}

.activity_bar__project_menu_item {
    display: block;
    width: 100%;
    padding: 10px 15px;
    text-align: left;
    background: none;
    border: none;
    color: var(--color-text);
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.1s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (pointer: fine) {
    .activity_bar__project_menu_item:hover {
        background-color: var(--color-bg-3);
    }
}

.activity_bar__project_menu_item.active {
    color: var(--color-accent);
}

.activity_bar__project_menu_new {
    display: block;
    width: 100%;
    padding: 10px 15px;
    text-align: left;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 14px;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__project_menu_new:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.activity_bar__project_menu_close {
    display: block;
    width: 100%;
    padding: 10px 15px;
    text-align: left;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 14px;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__project_menu_close:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

/* Settings button */

.activity_bar__settings_btn {
    display: block;
    width: 100%;
    padding: 10px 15px;
    text-align: left;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 14px;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__settings_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

/* Settings modal */

.activity_bar__settings_modal {
    width: 418px;
    max-width: calc(100vw - 30px);
}

/* Mobile — settings modal fills the whole screen. !important overrides the
   inline top-pinning styles the component sets for the centered desktop case. */
@media (max-width: 845px) {
    .activity_bar__settings_modal {
        width: 100% !important;
        max-width: 100% !important;
        height: 100dvh;
        max-height: 100dvh !important;
        margin-top: 0 !important;
        border-radius: 0;
        border: none;
    }
}

.activity_bar__settings_tabs {
    display: flex;
    gap: 2px;
    border-bottom: 1px solid var(--color-border);
    flex-shrink: 0;
}

.activity_bar__settings_tab {
    padding: 7px 13px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    cursor: pointer;
    color: var(--color-text-muted);
    font-size: 14px;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__settings_tab:hover {
        color: var(--color-text);
    }
}

.activity_bar__settings_tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.activity_bar__dialog_body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 13px;
    /* Slight padding so scrollbar doesn't overlap content */
    padding-right: 2px;
}

.activity_bar__settings_section {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.activity_bar__settings_section_title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--color-text-muted);
    padding: 2px 0 2px;
}

/* SSH keys */

.activity_bar__ssh_keys_list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.activity_bar__ssh_keys_empty {
    font-size: 13px;
    color: var(--color-text-muted);
    padding: 4px 0;
}

.activity_bar__ssh_key_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 11px;
    padding: 9px 11px;
    border-radius: 4px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
}

.activity_bar__ssh_key_item--active {
    border-color: var(--color-accent);
}

.activity_bar__ssh_key_info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.activity_bar__ssh_key_name {
    font-size: 14px;
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.activity_bar__ssh_key_actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
}

.activity_bar__ssh_key_use,
.activity_bar__ssh_key_remove {
    flex-shrink: 0;
    padding: 5px 11px;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    border: none;
    background-color: var(--color-bg-3);
    color: var(--color-text-muted);
    transition: background-color 0.1s, color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__ssh_key_use:hover,
    .activity_bar__ssh_key_remove:hover {
        background-color: var(--color-border);
        color: var(--color-text);
    }
}

.activity_bar__ssh_key_active {
    flex-shrink: 0;
    padding: 5px 11px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: none;
    color: var(--color-accent);
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__ssh_key_active:hover {
        background-color: var(--color-border);
    }
}

/* Separator + header above the "new key" form */

.activity_bar__ssh_form_header {
    margin-top: 4px;
    padding-top: 15px;
    border-top: 1px solid var(--color-border);
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text);
}

/* Upload-or-type row for a key field */

.activity_bar__ssh_key_input_row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.activity_bar__ssh_file_input {
    display: none;
}

.activity_bar__ssh_upload_btn {
    flex-shrink: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: var(--color-bg-3);
    color: var(--color-text);
}

@media (pointer: fine) {
    .activity_bar__ssh_upload_btn:hover {
        background-color: var(--color-border);
    }
}

.activity_bar__ssh_manual_toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--color-text-muted);
    cursor: pointer;
    user-select: none;
}

.activity_bar__ssh_manual_toggle input {
    cursor: pointer;
}

/* Theme picker */

.activity_bar__theme_list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.activity_bar__theme_item {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 100%;
    padding: 9px 11px;
    border-radius: 4px;
    background: none;
    border: 1px solid transparent;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.1s, border-color 0.1s;
    color: var(--color-text);
    font-size: 14px;
}

@media (pointer: fine) {
    .activity_bar__theme_item:hover {
        background-color: var(--color-bg-3);
    }
}

.activity_bar__theme_item.active {
    border-color: var(--color-accent);
    background-color: var(--color-bg-3);
}

.activity_bar__theme_swatch {
    flex-shrink: 0;
    width: 40px;
    height: 26px;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: flex-end;
    padding: 3px;
}

.activity_bar__theme_swatch_accent {
    width: 100%;
    height: 4px;
    border-radius: 2px;
}

.activity_bar__theme_name {
    flex: 1;
}

.activity_bar__theme_check {
    color: var(--color-accent);
    font-size: 15px;
    font-weight: 600;
}

/* Language picker */

.activity_bar__language_list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.activity_bar__language_item {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 100%;
    padding: 9px 11px;
    border-radius: 4px;
    background: none;
    border: 1px solid transparent;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.1s, border-color 0.1s;
    color: var(--color-text);
    font-size: 14px;
}

@media (pointer: fine) {
    .activity_bar__language_item:hover {
        background-color: var(--color-bg-3);
    }
}

.activity_bar__language_item.active {
    border-color: var(--color-accent);
    background-color: var(--color-bg-3);
}

.activity_bar__language_name {
    flex: 1;
}

.activity_bar__language_subname {
    font-size: 12px;
    color: var(--color-text-muted);
}

/* New project dialog */

.activity_bar__dialog_overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.activity_bar__dialog {
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 9px;
    box-shadow: 0 9px 35px rgba(0, 0, 0, 0.5);
    padding: 22px;
    width: 352px;
    max-width: calc(100vw - 30px);
    max-height: calc(100dvh - 40px);
    display: flex;
    flex-direction: column;
    gap: 13px;
    overflow: hidden;
}

.activity_bar__dialog_title {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-text);
}

.activity_bar__dialog_input {
    width: 100%;
    padding: 8px 11px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    color: var(--color-text);
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.1s;
}

.activity_bar__dialog_input:focus {
    border-color: var(--color-accent);
}

.activity_bar__settings_number_input {
    width: 80px;
    padding: 6px 10px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    color: var(--color-text);
    font-size: 14px;
    outline: none;
    transition: border-color 0.1s;
}

.activity_bar__settings_number_input:focus {
    border-color: var(--color-accent);
}

.activity_bar__dialog_actions {
    display: flex;
    justify-content: flex-end;
    gap: 9px;
    flex-shrink: 0;
}

.activity_bar__dialog_btn {
    padding: 7px 15px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    transition: background-color 0.1s, opacity 0.1s;
}

.activity_bar__dialog_btn--cancel {
    background-color: var(--color-bg-3);
    color: var(--color-text-muted);
}

@media (pointer: fine) {
    .activity_bar__dialog_btn--cancel:hover {
        background-color: var(--color-border);
        color: var(--color-text);
    }
}

.activity_bar__dialog_btn--create {
    background-color: var(--color-accent);
    color: #ffffff;
}

@media (pointer: fine) {
    .activity_bar__dialog_btn--create:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.activity_bar__dialog_btn--create:disabled {
    opacity: 0.4;
    cursor: default;
}

/* Setup agent modal */

.activity_bar__setup_agent_modal {
    width: 480px;
    max-width: calc(100vw - 40px);
}

.activity_bar__setup_step_title {
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text);
    margin-top: 4px;
}

.activity_bar__setup_step_desc {
    font-size: 13px;
    color: var(--color-text-muted);
    margin-top: -6px;
}

.activity_bar__setup_code {
    display: block;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 5px;
    padding: 9px 13px;
    font-size: 13px;
    font-family: monospace;
    color: var(--color-text);
    white-space: pre;
    overflow-x: auto;
    cursor: text;
    outline: none;
}

.activity_bar__setup_code:focus {
    border-color: var(--color-accent);
}

.activity_bar__setup_code--block {
    line-height: 1.6;
}

.activity_bar__setup_token_row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.activity_bar__setup_token_label {
    font-size: 13px;
    color: var(--color-text-muted);
    white-space: nowrap;
}

.activity_bar__setup_token {
    flex: 1;
    min-width: 0;
    font-family: monospace;
    font-size: 12px;
    color: var(--color-text-muted);
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    padding: 4px 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: text;
    outline: none;
}

.activity_bar__setup_token:focus {
    border-color: var(--color-accent);
    color: var(--color-text);
    text-overflow: clip;
    overflow: auto;
}

/* Zoom slider control */

.activity_bar__zoom_control {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 13px;
    gap: 7px;
    user-select: none;
}

.activity_bar__zoom_close_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    background: none;
    border: none;
    border-radius: 4px;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .activity_bar__zoom_close_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.activity_bar__zoom_track {
    position: relative;
    width: 14px;
    height: 120px;
    cursor: pointer;
    touch-action: none;
}

.activity_bar__zoom_track::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    transform: translateX(-50%);
    width: 2px;
    background: var(--color-border);
    border-radius: 1px;
}

.activity_bar__zoom_fill {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 2px;
    background: var(--color-accent);
    border-radius: 1px;
    pointer-events: none;
}

.activity_bar__zoom_knob {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: var(--color-accent);
    pointer-events: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.activity_bar__zoom_label {
    font-size: 10px;
    color: var(--color-text-muted);
    font-variant-numeric: tabular-nums;
}

/* Portrait mobile — horizontal tab bar at the bottom */

@media (max-width: 845px) and (orientation: portrait) {
    .activity_bar {
        flex-direction: row;
        width: 100%;
        height: 62px;
        border-right: none;
        border-top: 1px solid var(--color-border);
        position: relative;
        z-index: 1060;
    }

    .activity_bar__nav {
        flex-direction: row;
        flex: 1;
    }

    .activity_bar__item {
        flex: 1;
        width: auto;
        height: 100%;
        border-left: none;
        border-top: 2px solid transparent;
    }

    .activity_bar__item.active {
        border-left-color: transparent;
        border-top-color: var(--color-accent);
    }

    .activity_bar__item_label {
        writing-mode: horizontal-tb;
        font-size: 11px;
        letter-spacing: 0.05em;
    }

    .activity_bar__separator {
        height: auto;
        width: 1px;
        margin: 9px 4px;
    }

    .activity_bar__bottom {
        padding-bottom: 0;
        padding-right: 13px;
        margin-top: 0;
        margin-left: auto;
        align-self: center;
    }

    /* Account menu opens upward from the avatar */
    .activity_bar__account_menu {
        bottom: calc(100% + 9px);
        left: auto;
        right: 0;
    }

}
`, "",{"version":3,"sources":["webpack://./components/ActivityBar/s.activity_bar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,2CAA2C;IAC3C,cAAc;IACd,iBAAiB;AACrB;;AAEA,cAAc;;AAEd;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,qDAAqD;;AAErD;IACI,WAAW;IACX,qCAAqC;IACrC,eAAe;IACf,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA,gFAAgF;;AAEhF;IACI,eAAe;IACf,QAAQ;IACR,aAAa;AACjB;;AAEA,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA,oBAAoB;;AAEpB;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA,mBAAmB;;AAEnB;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;gFACgF;AAChF;IACI;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,cAAc;QACd,6BAA6B;QAC7B,wBAAwB;QACxB,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,aAAa;;AAEb;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mCAAmC;IACnC,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI;;QAEI,qCAAqC;QACrC,wBAAwB;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA,gDAAgD;;AAEhD;IACI,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,uCAAuC;;AAEvC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AAEjB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oDAAoD;IACpD,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oDAAoD;IACpD,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA,uBAAuB;;AAEvB;IACI,eAAe;IACf,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI;QACI,qCAAqC;QACrC,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,sBAAsB;;AAEtB;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,8BAA8B;IAC9B,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA,uDAAuD;;AAEvD;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yCAAyC;QACzC,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,OAAO;IACX;;IAEA;QACI,OAAO;QACP,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;IACrC;;IAEA;QACI,8BAA8B;QAC9B,qCAAqC;IACzC;;IAEA;QACI,2BAA2B;QAC3B,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA,8CAA8C;IAC9C;QACI,wBAAwB;QACxB,UAAU;QACV,QAAQ;IACZ;;AAEJ","sourcesContent":[".activity_bar {\n    display: flex;\n    flex-direction: column;\n    width: 53px;\n    height: 100%;\n    background-color: var(--color-bg-2);\n    border-right: 1px solid var(--color-border);\n    flex-shrink: 0;\n    overflow: visible;\n}\n\n/* Nav items */\n\n.activity_bar__nav {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.activity_bar__item {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 53px;\n    height: 53px;\n    background: none;\n    border: none;\n    border-left: 2px solid transparent;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    padding: 0;\n    transition: color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__item:hover {\n        color: var(--color-text);\n    }\n}\n\n.activity_bar__item.active {\n    color: var(--color-text);\n    border-left-color: var(--color-accent);\n}\n\n.activity_bar__item_label {\n    writing-mode: vertical-lr;\n    font-size: 12px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    user-select: none;\n}\n\n/* Separator between section items and toggle items */\n\n.activity_bar__separator {\n    height: 1px;\n    background-color: var(--color-border);\n    margin: 4px 9px;\n    flex-shrink: 0;\n}\n\n/* Account at bottom */\n\n.activity_bar__bottom {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 13px;\n    margin-top: auto;\n}\n\n.activity_bar__account_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    border-radius: 50%;\n}\n\n.activity_bar__avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 31px;\n    height: 31px;\n    border-radius: 50%;\n    background-color: var(--color-accent);\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    user-select: none;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__account_btn:hover .activity_bar__avatar {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.activity_bar__account_dropdown[data-open=\"false\"] {\n    opacity: 0;\n    pointer-events: none;\n}\n\n/* Full-screen backdrop — blocks clicks from reaching elements behind the menu */\n\n.activity_bar__account_backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1099;\n}\n\n/* Account dropdown — opens right and up from the avatar */\n\n.activity_bar__account_menu {\n    position: absolute;\n    bottom: 0;\n    left: calc(100% + 9px);\n    min-width: 220px;\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 7px;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.4);\n    z-index: 1100;\n    overflow: hidden;\n}\n\n.activity_bar__account_info {\n    padding: 13px 15px;\n}\n\n.activity_bar__account_info_row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.activity_bar__account_info_text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-width: 0;\n}\n\n.activity_bar__account_name {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--color-text);\n}\n\n.activity_bar__account_email {\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.activity_bar__refresh_btn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 5px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__refresh_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__new_window_btn {\n    display: none;\n}\n\n@media (pointer: fine) {\n    .activity_bar__new_window_btn {\n        display: flex;\n    }\n}\n\n.activity_bar__account_divider {\n    height: 1px;\n    background-color: var(--color-border);\n}\n\n.activity_bar__sign_out {\n    display: block;\n    width: 100%;\n    padding: 10px 15px;\n    text-align: left;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__sign_out:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__project_menu_empty {\n    padding: 10px 15px;\n    font-size: 14px;\n    color: var(--color-text-muted);\n}\n\n.activity_bar__project_menu_item {\n    display: block;\n    width: 100%;\n    padding: 10px 15px;\n    text-align: left;\n    background: none;\n    border: none;\n    color: var(--color-text);\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.1s;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (pointer: fine) {\n    .activity_bar__project_menu_item:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__project_menu_item.active {\n    color: var(--color-accent);\n}\n\n.activity_bar__project_menu_new {\n    display: block;\n    width: 100%;\n    padding: 10px 15px;\n    text-align: left;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__project_menu_new:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__project_menu_close {\n    display: block;\n    width: 100%;\n    padding: 10px 15px;\n    text-align: left;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__project_menu_close:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* Settings button */\n\n.activity_bar__settings_btn {\n    display: block;\n    width: 100%;\n    padding: 10px 15px;\n    text-align: left;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__settings_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* Settings modal */\n\n.activity_bar__settings_modal {\n    width: 418px;\n    max-width: calc(100vw - 30px);\n}\n\n/* Mobile — settings modal fills the whole screen. !important overrides the\n   inline top-pinning styles the component sets for the centered desktop case. */\n@media (max-width: 845px) {\n    .activity_bar__settings_modal {\n        width: 100% !important;\n        max-width: 100% !important;\n        height: 100dvh;\n        max-height: 100dvh !important;\n        margin-top: 0 !important;\n        border-radius: 0;\n        border: none;\n    }\n}\n\n.activity_bar__settings_tabs {\n    display: flex;\n    gap: 2px;\n    border-bottom: 1px solid var(--color-border);\n    flex-shrink: 0;\n}\n\n.activity_bar__settings_tab {\n    padding: 7px 13px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -1px;\n    cursor: pointer;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__settings_tab:hover {\n        color: var(--color-text);\n    }\n}\n\n.activity_bar__settings_tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.activity_bar__dialog_body {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    /* Slight padding so scrollbar doesn't overlap content */\n    padding-right: 2px;\n}\n\n.activity_bar__settings_section {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n.activity_bar__settings_section_title {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--color-text-muted);\n    padding: 2px 0 2px;\n}\n\n/* SSH keys */\n\n.activity_bar__ssh_keys_list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.activity_bar__ssh_keys_empty {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    padding: 4px 0;\n}\n\n.activity_bar__ssh_key_item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 11px;\n    padding: 9px 11px;\n    border-radius: 4px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n}\n\n.activity_bar__ssh_key_item--active {\n    border-color: var(--color-accent);\n}\n\n.activity_bar__ssh_key_info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.activity_bar__ssh_key_name {\n    font-size: 14px;\n    color: var(--color-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.activity_bar__ssh_key_actions {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.activity_bar__ssh_key_use,\n.activity_bar__ssh_key_remove {\n    flex-shrink: 0;\n    padding: 5px 11px;\n    border-radius: 4px;\n    font-size: 13px;\n    cursor: pointer;\n    border: none;\n    background-color: var(--color-bg-3);\n    color: var(--color-text-muted);\n    transition: background-color 0.1s, color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__ssh_key_use:hover,\n    .activity_bar__ssh_key_remove:hover {\n        background-color: var(--color-border);\n        color: var(--color-text);\n    }\n}\n\n.activity_bar__ssh_key_active {\n    flex-shrink: 0;\n    padding: 5px 11px;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    background: none;\n    color: var(--color-accent);\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__ssh_key_active:hover {\n        background-color: var(--color-border);\n    }\n}\n\n/* Separator + header above the \"new key\" form */\n\n.activity_bar__ssh_form_header {\n    margin-top: 4px;\n    padding-top: 15px;\n    border-top: 1px solid var(--color-border);\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n/* Upload-or-type row for a key field */\n\n.activity_bar__ssh_key_input_row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.activity_bar__ssh_file_input {\n    display: none;\n}\n\n.activity_bar__ssh_upload_btn {\n    flex-shrink: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background-color: var(--color-bg-3);\n    color: var(--color-text);\n}\n\n@media (pointer: fine) {\n    .activity_bar__ssh_upload_btn:hover {\n        background-color: var(--color-border);\n    }\n}\n\n.activity_bar__ssh_manual_toggle {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    user-select: none;\n}\n\n.activity_bar__ssh_manual_toggle input {\n    cursor: pointer;\n}\n\n/* Theme picker */\n\n.activity_bar__theme_list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.activity_bar__theme_item {\n    display: flex;\n    align-items: center;\n    gap: 11px;\n    width: 100%;\n    padding: 9px 11px;\n    border-radius: 4px;\n    background: none;\n    border: 1px solid transparent;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.1s, border-color 0.1s;\n    color: var(--color-text);\n    font-size: 14px;\n}\n\n@media (pointer: fine) {\n    .activity_bar__theme_item:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__theme_item.active {\n    border-color: var(--color-accent);\n    background-color: var(--color-bg-3);\n}\n\n.activity_bar__theme_swatch {\n    flex-shrink: 0;\n    width: 40px;\n    height: 26px;\n    border-radius: 3px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: flex-end;\n    padding: 3px;\n}\n\n.activity_bar__theme_swatch_accent {\n    width: 100%;\n    height: 4px;\n    border-radius: 2px;\n}\n\n.activity_bar__theme_name {\n    flex: 1;\n}\n\n.activity_bar__theme_check {\n    color: var(--color-accent);\n    font-size: 15px;\n    font-weight: 600;\n}\n\n/* Language picker */\n\n.activity_bar__language_list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.activity_bar__language_item {\n    display: flex;\n    align-items: center;\n    gap: 11px;\n    width: 100%;\n    padding: 9px 11px;\n    border-radius: 4px;\n    background: none;\n    border: 1px solid transparent;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.1s, border-color 0.1s;\n    color: var(--color-text);\n    font-size: 14px;\n}\n\n@media (pointer: fine) {\n    .activity_bar__language_item:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__language_item.active {\n    border-color: var(--color-accent);\n    background-color: var(--color-bg-3);\n}\n\n.activity_bar__language_name {\n    flex: 1;\n}\n\n.activity_bar__language_subname {\n    font-size: 12px;\n    color: var(--color-text-muted);\n}\n\n/* New project dialog */\n\n.activity_bar__dialog_overlay {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n}\n\n.activity_bar__dialog {\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 9px;\n    box-shadow: 0 9px 35px rgba(0, 0, 0, 0.5);\n    padding: 22px;\n    width: 352px;\n    max-width: calc(100vw - 30px);\n    max-height: calc(100dvh - 40px);\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    overflow: hidden;\n}\n\n.activity_bar__dialog_title {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n.activity_bar__dialog_input {\n    width: 100%;\n    padding: 8px 11px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    color: var(--color-text);\n    font-size: 14px;\n    outline: none;\n    box-sizing: border-box;\n    transition: border-color 0.1s;\n}\n\n.activity_bar__dialog_input:focus {\n    border-color: var(--color-accent);\n}\n\n.activity_bar__settings_number_input {\n    width: 80px;\n    padding: 6px 10px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    color: var(--color-text);\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.1s;\n}\n\n.activity_bar__settings_number_input:focus {\n    border-color: var(--color-accent);\n}\n\n.activity_bar__dialog_actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 9px;\n    flex-shrink: 0;\n}\n\n.activity_bar__dialog_btn {\n    padding: 7px 15px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.1s, opacity 0.1s;\n}\n\n.activity_bar__dialog_btn--cancel {\n    background-color: var(--color-bg-3);\n    color: var(--color-text-muted);\n}\n\n@media (pointer: fine) {\n    .activity_bar__dialog_btn--cancel:hover {\n        background-color: var(--color-border);\n        color: var(--color-text);\n    }\n}\n\n.activity_bar__dialog_btn--create {\n    background-color: var(--color-accent);\n    color: #ffffff;\n}\n\n@media (pointer: fine) {\n    .activity_bar__dialog_btn--create:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.activity_bar__dialog_btn--create:disabled {\n    opacity: 0.4;\n    cursor: default;\n}\n\n/* Setup agent modal */\n\n.activity_bar__setup_agent_modal {\n    width: 480px;\n    max-width: calc(100vw - 40px);\n}\n\n.activity_bar__setup_step_title {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--color-text);\n    margin-top: 4px;\n}\n\n.activity_bar__setup_step_desc {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    margin-top: -6px;\n}\n\n.activity_bar__setup_code {\n    display: block;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 5px;\n    padding: 9px 13px;\n    font-size: 13px;\n    font-family: monospace;\n    color: var(--color-text);\n    white-space: pre;\n    overflow-x: auto;\n    cursor: text;\n    outline: none;\n}\n\n.activity_bar__setup_code:focus {\n    border-color: var(--color-accent);\n}\n\n.activity_bar__setup_code--block {\n    line-height: 1.6;\n}\n\n.activity_bar__setup_token_row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.activity_bar__setup_token_label {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    white-space: nowrap;\n}\n\n.activity_bar__setup_token {\n    flex: 1;\n    min-width: 0;\n    font-family: monospace;\n    font-size: 12px;\n    color: var(--color-text-muted);\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: text;\n    outline: none;\n}\n\n.activity_bar__setup_token:focus {\n    border-color: var(--color-accent);\n    color: var(--color-text);\n    text-overflow: clip;\n    overflow: auto;\n}\n\n/* Zoom slider control */\n\n.activity_bar__zoom_control {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px 0 13px;\n    gap: 7px;\n    user-select: none;\n}\n\n.activity_bar__zoom_close_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 4px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .activity_bar__zoom_close_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.activity_bar__zoom_track {\n    position: relative;\n    width: 14px;\n    height: 120px;\n    cursor: pointer;\n    touch-action: none;\n}\n\n.activity_bar__zoom_track::before {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 0;\n    bottom: 0;\n    transform: translateX(-50%);\n    width: 2px;\n    background: var(--color-border);\n    border-radius: 1px;\n}\n\n.activity_bar__zoom_fill {\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    transform: translateX(-50%);\n    width: 2px;\n    background: var(--color-accent);\n    border-radius: 1px;\n    pointer-events: none;\n}\n\n.activity_bar__zoom_knob {\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    background: var(--color-accent);\n    pointer-events: none;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n}\n\n.activity_bar__zoom_label {\n    font-size: 10px;\n    color: var(--color-text-muted);\n    font-variant-numeric: tabular-nums;\n}\n\n/* Portrait mobile — horizontal tab bar at the bottom */\n\n@media (max-width: 845px) and (orientation: portrait) {\n    .activity_bar {\n        flex-direction: row;\n        width: 100%;\n        height: 62px;\n        border-right: none;\n        border-top: 1px solid var(--color-border);\n        position: relative;\n        z-index: 1060;\n    }\n\n    .activity_bar__nav {\n        flex-direction: row;\n        flex: 1;\n    }\n\n    .activity_bar__item {\n        flex: 1;\n        width: auto;\n        height: 100%;\n        border-left: none;\n        border-top: 2px solid transparent;\n    }\n\n    .activity_bar__item.active {\n        border-left-color: transparent;\n        border-top-color: var(--color-accent);\n    }\n\n    .activity_bar__item_label {\n        writing-mode: horizontal-tb;\n        font-size: 11px;\n        letter-spacing: 0.05em;\n    }\n\n    .activity_bar__separator {\n        height: auto;\n        width: 1px;\n        margin: 9px 4px;\n    }\n\n    .activity_bar__bottom {\n        padding-bottom: 0;\n        padding-right: 13px;\n        margin-top: 0;\n        margin-left: auto;\n        align-self: center;\n    }\n\n    /* Account menu opens upward from the avatar */\n    .activity_bar__account_menu {\n        bottom: calc(100% + 9px);\n        left: auto;\n        right: 0;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
